module.exports = "/images/logo-eit-white.svg?e9c442147a2ce58b505a157a3cf7c001";